export enum ConnectionType {
  serialPort,
  serialPortConnection,
  lanConnection,
}
